import { render, staticRenderFns } from "./ExtraSettingsSelector.vue?vue&type=template&id=19e7bf6c&"
import script from "./ExtraSettingsSelector.vue?vue&type=script&lang=js&"
export * from "./ExtraSettingsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports